<span class="purchaser-input" tabindex="0">
  <input
    type="text"
    name="purchaser"
    [placeholder]="placeholder"
    (keyup)="searchOrgs($event)"
    [value]="value"
    #orgSearch />
  @if (searchType === 'Organization' || searchType === 'Fund') {
    <div
      class="org-typeahead mat-elevation-z8"
      >
      <ul class="orgs">
        @if (orgSearch.value.length === 0) {
          <li>Search or enter a name.</li>
        }
        @if (searching) {
          <li class="searching">
            <mat-icon inline>loop</mat-icon>
          </li>
        }
        @for (org of orgs$ | async; track org) {
          <li class="org">
            <a (click)="selectOrg(org)">{{ org.name }}</a>
          </li>
        }
        @if (
          !searching &&
          orgSearch.value.length > 0 &&
          searched &&
          !(orgs$ | async)?.length
          ) {
          <li
            >
            No matching organizations found.
          </li>
        }
      </ul>
    </div>
  }
</span>
